<template>
  <component
    :is="type"
    v-text="text"
  />
</template>

<script>

/**
 * Component: Heading
 * ------------------------------------------------------------------------------
 * - Outputs a H1-H6 element via the passed props
 * - Used for when the Shopify Customiser has a H1-H6 selector.
 * @param {String} text - Text to display within the element.
 * @param {String} type - Type of heading element to use.
 */
export default {
  name: 'Heading',

  props: {
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'h2',
      required: true,
      validator: (value) => {
        const levels = [
          'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        ]

        return Boolean(levels.includes(value))
      },
    },
  },
}
</script>